import React from 'react';
import AuthLayout from '../components/auth/AuthLayout';

const Onboarding = ({ onNavigate }) => (
  <AuthLayout
    title="Step 4 coming next: About"
    subtitle="We are building the rest of onboarding."
    cardClassName="px-8 py-6"
  >
    <div className="space-y-4 text-center">
      <p className="text-sm text-slate-600">
        You have completed Step 1. More onboarding steps will be available soon.
      </p>
      <button
        type="button"
        onClick={() => onNavigate('profile-edit')}
        className="h-11 w-full rounded-lg border border-slate-200 bg-white text-sm font-medium text-slate-700 transition hover:border-slate-300 hover:bg-slate-50"
      >
        Go to Profile Builder
      </button>
    </div>
  </AuthLayout>
);

export default Onboarding;
